import { createPortal } from "react-dom";
import { LunchMenuPrintView } from "./LunchMenuPrintView";
import "./lunchMenuPrint.css";

/**
 * Vždy primontovaný, na obrazovke skrytý tlačový rám denného menu. Obsah je stále v DOM
 * (aby sa načítalo logo aj rozloženie); pri tlači ho `@media print` zviditeľní a skryje
 * appku (#root). Portál je mimo #root (v document.body), aby ho skrytie #root nezasiahlo.
 */
export function LunchMenuPrintFrame(props) {
  if (typeof document === "undefined") {
    return null;
  }
  return createPortal(
    <div id="lunch-menu-print-portal" aria-hidden="true">
      <LunchMenuPrintView {...props} />
    </div>,
    document.body,
  );
}

/**
 * Otvorí natívny tlačový dialóg prehliadača (Tlačiť / Uložiť ako PDF) pre denné menu.
 * Pridá triedu `lmp-printing` (→ `@media print` ukáže len tlačový rám a skryje #root),
 * zavolá `window.print()` a po zatvorení dialógu (afterprint) triedu odstráni.
 */
export function triggerDailyMenuPrint() {
  if (typeof window === "undefined") {
    return;
  }
  document.documentElement.classList.add("lmp-printing");
  const cleanup = () => {
    document.documentElement.classList.remove("lmp-printing");
    window.removeEventListener("afterprint", cleanup);
  };
  window.addEventListener("afterprint", cleanup);
  requestAnimationFrame(() => window.print());
}
